import React, { useContext } from 'react';
import styled from 'styled-components';
import { Loader } from '@mummssoftware/common-ui';
import { FlexColumnCenterDiv } from '@mummssoftware/common-ui/style';
import { GlobalContext, priorVisit } from '@mummssoftware/global-context';
import { VisitContext } from '../Context/contexts/VisitContext';
import StartVisit from './StartVisit';
import RecordVisit from './RecordVisit';
import { PriorVisit } from './PriorVisit';
import { ErrorBoundary } from './ErrorBoundary';

const VisitInterfaceContainer = styled(FlexColumnCenterDiv)`
  width: 100%;
  @media (max-width: 600px) {
    justify-content: flex-start;
    align-items: stretch;
    padding-bottom: 4px;
    box-sizing: border-box;
  }
`;

export const VisitInterface = () => {
  const { savedVisit, visitOpen, closingPriorVisit } = useContext(VisitContext);
  const { levelOfCare } = useContext(GlobalContext);

  /*
   * Visit routing reads VisitContext (`visitOpen`, `savedVisit`) and GlobalContext
   * (`levelOfCare`). `reset()` clears all of them in one synchronous call, but they
   * live in separate providers, so React may commit updates independently. Between
   * commits VisitInterface can briefly see a mixed snapshot, e.g. `levelOfCare` null
   * while `savedVisit` is still set (RecordVisit) or both null while `visitOpen` is
   * still true (StartVisit).
   *
   * PriorVisit close is most exposed because routing checks `levelOfCare === priorVisit`
   * in addition to `savedVisit`. Close sets `closingPriorVisit` and clears `visitOpen`
   * before the PUT; Dashboard also hides `VisitDialogBox` while closing. `reset()`
   * clears the rest and drops `closingPriorVisit` last.
   *
   * RecordVisit submit is less affected: `visitOpen` and `savedVisit` share
   * VisitContext, so they update atomically. The `!visitOpen` guard below avoids
   * rendering StartVisit inside a closing visit dialog once the widget is closed.
   *
   * resolved in closing interface of prior visit
   */

  const getVisitInterface = () => {
    if (closingPriorVisit) {
      return <Loader />;
    }

    if (!visitOpen) {
      return null;
    }
    if (levelOfCare === priorVisit) {
      return <PriorVisit />;
    }
    if (savedVisit) {
      return <RecordVisit />;
    }
    return <StartVisit />;
  };

  return (
    <ErrorBoundary>
      <VisitInterfaceContainer className="app-visit-interface">
        {getVisitInterface()}
      </VisitInterfaceContainer>
    </ErrorBoundary>
  );
};
export default VisitInterface;
